import { createDeployPluginHeadless } from '../../_shared/common/createDeployPluginHeadless';
import { BARE_METAL_CAPABILITIES } from '../capabilities';
import { BARE_METAL_FIELD_KEYS } from '../fields';
import { BARE_METAL_MODULES } from '../modules';
import { bareMetalMigrations } from './migrations';
import {
  buildBareMetalDisplayDescriptors,
  buildBareMetalResourceConfigs,
  pickBareMetalPresetFields,
  serializeBareMetalApiBody,
} from './projections';
import { type BareMetalApiPayload, type BareMetalSpec, BareMetalSpecSchema } from './schema';
import { bareMetalFromForm, bareMetalGetInitialFormValues, bareMetalToForm } from './spec';

export const bareMetalHeadless = createDeployPluginHeadless<BareMetalSpec, BareMetalApiPayload, (typeof BARE_METAL_FIELD_KEYS)[number]>({
  code: 'BareMetal',
  fieldKeys: BARE_METAL_FIELD_KEYS,
  modules: BARE_METAL_MODULES,
  capabilities: BARE_METAL_CAPABILITIES,
  schema: BareMetalSpecSchema,
  fromForm: bareMetalFromForm,
  toForm: bareMetalToForm,
  getInitialFormValues: bareMetalGetInitialFormValues,
  projectionProfile: {
    profile: 'sku-capable',
    projections: {
      apiBody: serializeBareMetalApiBody,
      skuPreset: pickBareMetalPresetFields,
      buildDisplayDescriptors: buildBareMetalDisplayDescriptors,
      skuResources: buildBareMetalResourceConfigs,
    },
  },
  migrations: bareMetalMigrations,
});

export const bareMetalPipeline = bareMetalHeadless.pipeline;

export { bareMetalFromForm } from './spec';
export { buildBareMetalDeliveryMetadata, buildBareMetalOrderDeliveryMetadata } from './deliveryMetadata';
export type {
  BareMetalDeliveryMetadata,
  BuildBareMetalDeliveryMetadataContext,
  BuildBareMetalDeliveryMetadataInput,
  BuildBareMetalOrderDeliveryMetadataContext,
} from './deliveryMetadata';
